
//Dependencies
import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './Components/App';
import history from './history';
// Routes
import AppRoutes from './routes';

// ANTD
import { ConfigProvider } from 'antd';
import es_ES from 'antd/es/locale-provider/es_ES';

//Assets
import './index.css';
import 'antd/dist/antd.css';


import registerServiceWorker from './registerServiceWorker';


render(
	<ConfigProvider locale={es_ES}>
		<Router >
			<App />
		</Router>
	</ConfigProvider>
	, document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js